import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { initTelemetry } from '@services/telemetry/telemetry';
import './ag-grid-license';

declare global {
    interface Window {
        analytics: {
            track: (name: string, args: { [key: string]: unknown }, id: { groupId: string }) => void;
            page: (id?: string) => void;
        };
    }
}

if (environment.production) {
    enableProdMode();
}

// Before bootstrap, so errors thrown while the app starts are captured too.
initTelemetry();

platformBrowserDynamic()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch((err) => console.error(err));
